import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
const modalRoot = document.getElementById('modal-root');
/**
 * Modal
 */
class Modal extends React.Component {
  static displayName = 'AppRootModal';
  /**
   * @override
   */
  constructor(props) {
    super(props);
    this.el = document.createElement('div');
  }

  /**
   * @override
   */
  componentDidMount() {
    // L’élément portail est inséré dans l’arborescence DOM une fois
    // que les enfants du Modal sont montés, ce qui signifie que
    // les enfants seront montés sur un nœud DOM détaché.
    // Si un composant enfant nécessite d’être attaché au DOM
    // dès le montage, par exemple pour mesurer un nœud DOM ou
    // utiliser 'autoFocus' dans un nœud descendant, ajoutez un état
    // à la modale et affichez uniquement les enfants une fois la
    // modale insérée dans le DOM.
    modalRoot.appendChild(this.el);
  }

  /**
   * @override
   */
  componentWillUnmount() {
    modalRoot.removeChild(this.el);
  }

  /**
   * @override
   */
  render() {
    return ReactDOM.createPortal(this.props.children, this.el);
  }
}

Modal.propTypes = {
  children: PropTypes.any,
};
export default Modal;



// WEBPACK FOOTER //
// ./src/Modal.js